import { createFileRoute } from '@tanstack/react-router';

import { LegalPageLayout } from '@/features/legal/components/legalPageLayout';
import { TermsOfServiceContent } from '@/features/legal/components/termsOfServiceContent';

export const Route = createFileRoute('/terms')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <LegalPageLayout title="Terms of Service">
      <TermsOfServiceContent />
    </LegalPageLayout>
  );
}
